import { makeStyles } from 'tss-react/mui';

const CaseInfoStyles = makeStyles()((theme) => {
    return {
        title: {
            color: theme.palette.primary.main,
        },
        container: {
            borderRadius: 4,
            padding: 10,
        },
    };
});

export default CaseInfoStyles;
